import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Upload,
  Button,
  Space,
  message,
  Radio,
  Switch,
  Row,
  Col,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import axios from "./Services/Api";
import {baseURL} from "./api"

const { Option } = Select;

const AddMenuItem = ({ menuItemData, onUpdateSuccess }) => {
  const [form] = Form.useForm();
  const [restaurants, setRestaurants] = useState([]);
  const [mainTypes] = useState(["Veg", "Non-Veg"]);
  const [subTypes] = useState([
    "Patties",
    "Nuggets",
    "Zinger",
    "Fries",
    "Seekh-Kebab",
    "Paratha",
    "Others",
  ]);
  const isEditing = !!menuItemData;

  const role = localStorage.getItem("role");
  const vendorId = localStorage.getItem("vendorId")?.trim();

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await axios.get("/getRestaurants");
        let filteredRestaurants = response.data || [];

        if (role === "admin") {
          filteredRestaurants = filteredRestaurants.filter((r) => r.default);
        } else if (vendorId) {
          filteredRestaurants = filteredRestaurants.filter(
            (r) => r.vendorId?.trim() === vendorId
          );
        }

        if (filteredRestaurants.length === 0) {
          message.error("No restaurants available based on the current filters.");
        }

        setRestaurants(filteredRestaurants);
      } catch (error) {
        console.error("Error fetching restaurants:", error);
        message.error("Failed to fetch restaurants.");
      }
    };

    fetchRestaurants();

    if (isEditing) {
      form.setFieldsValue({
        ...menuItemData,
        img: menuItemData.imgPath
          ? [
              {
                uid: "-1",
                name: "existing-image",
                status: "done",
                url: `${baseURL}${menuItemData.imgPath}`,
              },
            ]
          : [],
        addOns: menuItemData.addOns || [],
        active: menuItemData.active ?? true,
      });
    } else {
      form.setFieldsValue({ price: 0 });
    }
  }, [form, isEditing, menuItemData, role, vendorId]);

  const onFinish = async (values) => {
    try {
      const formData = new FormData();
      formData.append("restaurantId", values.restaurantId);
      formData.append("name", values.name);
      formData.append("type", values.type);
      formData.append("subType", values.subType);
      formData.append("description", values.description);
      formData.append("price", values.price);
      formData.append("price500gm", values.price500gm)
      formData.append("addOns", JSON.stringify(values.addOns || []));
      formData.append("active", values.active);
      formData.append("restricted", values.restricted); // ✅ send restricted flag
      formData.append("new", values.new); 
      const normalizedCustomUnits = (values.customUnits || []).map((cu) => {
  if (cu.unit === "other") {
    return {
      qty: cu.qty,
      unit: cu.customUnit?.trim(), // 👈 inch goes here
      price: cu.price,
    };
  }
  return {
    qty: cu.qty,
    unit: cu.unit,
    price: cu.price,
  };
});

formData.append("customUnits", JSON.stringify(normalizedCustomUnits));


      // formData.append("new", values.new);

      if (values.img && values.img[0]?.originFileObj) {
        formData.append("img", values.img[0].originFileObj);
      }

      const response = await axios.post("/addMenuItem", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      message.success("Menu item added successfully");
      if (onUpdateSuccess) onUpdateSuccess();
    } catch (error) {
      console.error("Error adding menu item:", error);
      message.error("Failed to add menu item.");
    }
  };

  return (
    <Form
  form={form}
  layout="vertical"
  onFinish={onFinish}
  onValuesChange={(changed, all) => {
    // When custom unit is added → clear default prices
    if (changed.customUnits) {
      if ((all.customUnits || []).length > 0) {
        form.setFieldsValue({
          price: undefined,
          price500gm: undefined,
        });
      }
    }

    // When restricted is ON → clear custom units & set default prices
    if (changed.restricted === true) {
      form.setFieldsValue({
        customUnits: [],
        price: 0,
        price500gm: 0,
      });
    }
  }}
>

      <Form.Item
        name="restaurantId"
        label="Brand"
        rules={[{ required: true, message: "Please select the restaurant" }]}
      >
        <Select placeholder="Select Brand">
          {restaurants.map((restaurant) => (
            <Option key={restaurant._id} value={restaurant._id}>
              {restaurant.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="name"
        label="Menu Item Name"
        rules={[{ required: true, message: "Please enter the menu item name" }]}
      >
        <Input placeholder="Enter menu item name" />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Please select Veg or Non-Veg" }]}
      >
        <Radio.Group>
          {mainTypes.map((type) => (
            <Radio key={type} value={type}>
              {type}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="subType"
        label="Sub Type"
        rules={[{ required: true, message: "Please select a sub-type" }]}
      >
        <Select placeholder="Select sub-type">
          {subTypes.map((subType) => (
            <Option key={subType} value={subType}>
              {subType}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: true, message: "Please enter the description" }]}
      >
        <Input.TextArea placeholder="Enter description" />
      </Form.Item>

      <Form.Item
  shouldUpdate={(prev, curr) =>
    prev.restricted !== curr.restricted ||
    (prev.customUnits?.length || 0) !== (curr.customUnits?.length || 0)
  }
>

  {({ getFieldValue, setFieldsValue }) => {
    const restricted = getFieldValue("restricted");
const customUnits = getFieldValue("customUnits") || [];

const disableDefaultPrices = restricted || customUnits.length > 0;


    return (
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
  name="price"
  label="Price (1 Kg)"
  rules={
    disableDefaultPrices
      ? []
      : [{ required: true, message: "Please enter 1 Kg price" }]
  }
>
  <InputNumber
    style={{ width: "100%" }}
    placeholder="Enter 1 Kg price"
    disabled={disableDefaultPrices}
  />
</Form.Item>

        </Col>
        <Col span={8}>
         <Form.Item
  name="price500gm"
  label="Price (500 gm)"
  rules={
    disableDefaultPrices
      ? []
      : [{ required: true, message: "Please enter 500 gm price" }]
  }
>
  <InputNumber
    style={{ width: "100%" }}
    placeholder="Enter 500 gm price"
    disabled={disableDefaultPrices}
  />
</Form.Item>

        </Col>
      </Row>
    );
  }}
  
</Form.Item>

<Form.List name="customUnits">
  {(fields, { add, remove }) => (
    <>
      <label style={{ fontWeight: 600, marginTop: 16 }}>
        Additional Custom Units
      </label>

      {fields.map(({ key, name, ...restField }) => (
        <Row gutter={12} key={key} align="middle">
          <Col span={7}>
            <Form.Item
              {...restField}
              name={[name, "qty"]}
              rules={[{ required: true, message: "Qty required" }]}
            >
              <InputNumber min={1} style={{ width: "100%" }} placeholder="Qty" />
            </Form.Item>
          </Col>

          <Col span={7}>
  <Row gutter={8}>
    {/* LEFT: Unit Select */}
    <Col span={12}>
      <Form.Item
        {...restField}
        name={[name, "unit"]}
        rules={[{ required: true, message: "Unit required" }]}
      >
        <Select
          placeholder="Select unit"
          onChange={(val) => {
            if (val !== "other") {
              form.setFieldValue([name, "unit"], val);
            }
          }}
        >
          <Select.Option value="kg">kg</Select.Option>
          <Select.Option value="gm">gm</Select.Option>
          <Select.Option value="piece">piece</Select.Option>
          <Select.Option value="packet">packet</Select.Option>
          <Select.Option value="other">Other</Select.Option>
        </Select>
      </Form.Item>
    </Col>

    {/* RIGHT: Custom Unit Input */}
    <Col span={12}>
      <Form.Item
        shouldUpdate={(prev, curr) =>
          prev?.customUnits?.[name]?.unit !==
          curr?.customUnits?.[name]?.unit
        }
        noStyle
      >
        {({ getFieldValue }) =>
          getFieldValue(["customUnits", name, "unit"]) === "other" ? (
            <Form.Item
              name={[name, "customUnit"]}
              rules={[{ required: true, message: "Enter unit" }]}
            >
              <Input placeholder="Enter custom unit" />
            </Form.Item>
          ) : null
        }
      </Form.Item>
    </Col>
  </Row>
</Col>


          <Col span={7}>
            <Form.Item
              {...restField}
              name={[name, "price"]}
              rules={[{ required: true, message: "Price required" }]}
            >
              <InputNumber min={0} style={{ width: "100%" }} placeholder="Price" />
            </Form.Item>
          </Col>

          <Col span={3}>
            <MinusCircleOutlined onClick={() => remove(name)} />
          </Col>
        </Row>
      ))}

      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={() => add()}
        style={{ width: "60%"  , marginBottom:20 }}
      >
        Add Custom Unit
      </Button>
    </>
  )}
</Form.List>


<Row gutter={16}>
  <Col>
    <Form.Item name="active" label="Active Status" valuePropName="checked">
      <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
    </Form.Item>
  </Col>
  <Col>
    <Form.Item name="restricted" label="Restricted Item" valuePropName="checked">
      <Switch checkedChildren="Yes" unCheckedChildren="No" />
    </Form.Item>
  </Col>
  <Col>
    <Form.Item name="new" label="New Arrival" valuePropName="checked">
      <Switch checkedChildren="Yes" unCheckedChildren="No" />
    </Form.Item>
  </Col>
</Row>
      
      

      <Form.List name="addOns">
        {(fields, { add, remove }) => (
          <>
            <label>Add-ons</label>
            {fields.map(({ key, name, fieldKey, ...restField }) => (
              <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                <Form.Item
                  {...restField}
                  name={[name, "name"]}
                  rules={[{ required: true, message: "Missing add-on name" }]}
                >
                  <Input placeholder="Add-on name" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "price"]}
                  rules={[{ required: true, message: "Missing add-on price" }]}
                >
                  <InputNumber min={0} placeholder="Price" />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} style={{ width: "60%" }}>
              Add Add-on
            </Button>
          </>
        )}
      </Form.List>

      <Form.Item
        name="img"
        label="Upload Image"
        valuePropName="fileList"
        rules={[{ required: true, message: "Please upload an image" }]}
        getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
      >
        <Upload name="img" listType="picture" beforeUpload={() => false}>
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {isEditing ? "Update Menu Item" : "Add Menu Item"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddMenuItem;
